import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'antd/dist/antd.variable.css';
import './styles/theme.css';
import App from './App';

// 注入 antd 动态主题 CSS 变量（配合 antd.variable.css 使用，覆盖默认 #1890ff 系颜色）
ConfigProvider.config({
  theme: {
    primaryColor: '#1A509A',
  },
});

const RESIZE_OBSERVER_WARNINGS = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

const isResizeObserverWarning = (message = '') => (
  RESIZE_OBSERVER_WARNINGS.some((item) => String(message).includes(item))
);

window.addEventListener('error', (event) => {
  if (!isResizeObserverWarning(event?.message)) return;

  event.stopImmediatePropagation();
}, true);

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
